var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Download"},[(!_vm.showUrl)?_c('div',[_vm._v("\n    Arbetar, vänligen vänta.\n  ")]):_vm._e(),_vm._v(" "),(_vm.showUrl)?_c('div',[_vm._v("\n    Om filen eller sidan inte laddas, klicka på följande länk: "),_c('a',{attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.href))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed026380","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/download/Download.vue
// module id = null
// module chunks = 